<ng-template cdkPortal #actions="cdkPortal">
  <a class="btn btn-icon btn-secondary"
     [routerLink]="createPath"
     [queryParams]="query.filters">
    <icon-plus></icon-plus>
    <span class="ml-2">Add store version</span>
  </a>
</ng-template>

<smart-table [headers]="headers"
             [source]="source"
             (filtersChange)="onSearch($event)"
             (sortChange)="onSort($event)"
             [collapseAuto]="false"
             [collapseByClick]="true"
             (collapsedChange)="initForm($event)"
             [navigate]="editPath">
  <ng-template smartTableColumn="version" let-item>
    <td>
      <entity-link type="storeVersion"
                   bindLabel="version"
                   [item]="item"
                   [showInfo]="false"
                   [relativePath]="relativePath"
                   [isEntity]="isEntity">
      </entity-link>
    </td>
  </ng-template>

  <ng-template smartTableColumn="id" let-item>
    <td>
      {{ item.id }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="createdAt" let-item>
    <td>
      {{ item.createdAt | moment }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="updatedAt" let-item>
    <td>
      {{ item.updatedAt | moment }}
    </td>
  </ng-template>

  <ng-template smartTableCollapse let-item let-index="index" let-collapse="collapse">
    <form [formGroup]="forms[item.id]" (ngSubmit)="save(item, index)">
      <div class="row">
        <div class="col-60">
          <div class="form-group">
            <label>Version</label>
            <form-group-simple name="version" placeholder="Version" formControlName="version"></form-group-simple>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-30">
          <div class="form-group">
            <label>IOS</label>
            <form-group-files formControlName="appleAddressable"
                              [accepted]="acceptedFiles"
                              [single]="true"
                              [config]="{url: urlFilesUpload, params: {storeVersionId: item.id, platform: platformApple}}">
            </form-group-files>
          </div>
        </div>
        <div class="col-30">
          <div class="form-group">
            <label>Android</label>
            <form-group-files formControlName="googleAddressable"
                              [accepted]="acceptedFiles"
                              [single]="true"
                              [config]="{url: urlFilesUpload, params: {storeVersionId: item.id, platform: platformGoogle}}">
            </form-group-files>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-auto">
<!--          <btn-delete form actions type="store version"-->
<!--                      [name]="item.name"-->
<!--                      (delete)="delete($event, item.id)">-->
<!--          </btn-delete>-->
        </div>
        <div class="col-auto ml-auto">
          <div class="m-n2">
            <button class="btn btn-success m-2" type="submit" [disabled]="forms[item.id].disabled">
              Save
            </button>
            <button class="btn btn-outline-info m-2" type="button"
                    (click)="cancel(collapse)">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </form>
  </ng-template>
</smart-table>

<pagination [itemsOnPage]="pagination.limit"
            [page]="pagination.currentPage"
            (pageChanged)="setPage($event)"
            [itemsFull]="pagination.fullCount"></pagination>

<preloader [hidden]="!loaderService.isLoading"></preloader>

